import { configureStore } from '@reduxjs/toolkit';
import purchase from './reducers/purchase/purchase';
import customer from './reducers/customer/customer';
import errors from './reducers/errors/errors';
import chooseYourPlan from './reducers/chooseYourPlan/chooseYourPlan';
import intro from './reducers/intro/intro';

export const store = configureStore({
  reducer: {
    purchase,
    chooseYourPlan,
    errors,
    customer,
    intro,
  },
  devTools: true,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
